import { render, staticRenderFns } from "./ofd-view.vue?vue&type=template&id=0cabb758&scoped=true"
import script from "./ofd-view.vue?vue&type=script&lang=js"
export * from "./ofd-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cabb758",
  null
  
)

export default component.exports